import { Menu } from '@/components/organisms/Menu/Menu'
import React from 'react'
import { Footer } from '@/components/organisms/Footer/Footer'
import { NavLink } from '@/components/atoms/NavLink/NavLink'
import Image from 'next/image'
import { HelpList } from '@/components/organisms/HelpList/HelpList'
import { helplist } from '@/data/dummy/helplist'

import testi from '@/styles/help_center/index.module.scss'
export default function index () {
  function chunk (arr, size) {
    return arr.reduce((result, item, index) => {
      const chunkIndex = Math.floor(index / size)
      if (!result[chunkIndex]) {
        result[chunkIndex] = []
      }
      result[chunkIndex].push(item)
      return result
    }, [])
  };

  const helplistGrups = chunk(helplist, 2)
  return (
    <>

      <Menu />
      <div style={{ backgroundColor: '#ffffff' }}>
        <div className={testi.body_section}>
          <div className={testi.image_container}>
            <Image
              src='/img/help_center/soporte.png'
              className={testi.logo1}
              alt='Picture of the author '
              width={479}
              height={450}
            />
          </div>
          <div className={testi.title_container}>
            <h2 className={testi.title1}>Hola <br /> ¿En qué podemos ayudarte?</h2>
          </div>
        </div>
        <div className={testi.body_section3}>
          <div className={testi.card}>
            <div className={testi.column}>
              <div className={testi.horizontal}>
                <div className={testi.verticalText}>
                  <Image
                    src='/img/help_center/question.svg'
                    className={testi.logo2}
                    alt='Picture of the author '
                    width={128}
                    height={128}
                    style={{ marginTop: '20px' }}
                  />
                  <p className={testi.title}>Resuelve tus dudas</p>
                  <div className={testi.lista}>
                    <p className={testi.title2}>Lo más seguro es que puedas resolver tus dudas usando el buscador.</p>
                    <p className={testi.title2}>En caso contrario, contacta con nosotros</p>
                    <div className={testi.lista2} />
                    <NavLink href='/help_center/contact_us' name='Contacta' className={testi.button1} />
                  </div>

                </div>

              </div>
            </div>
            <div className={testi.column} />
          </div>
          <div className={testi.card}>
            <div className={testi.column}>
              <div className={testi.horizontal}>
                <div className={testi.verticalText}>
                  <Image
                    src='/img/help_center/video.svg'
                    className={testi.logo2}
                    alt='Picture of the author '
                    width={148}
                    height={148}
                  />
                  <p className={testi.title}>Algunos vídeos</p>
                  <div className={testi.lista}>
                    <p className={testi.title2}>Videos de procesos y configuraciones de Basys</p>
                    <p className={testi.title3}>Videos cortos y videos tutoriales por sectores.</p>

                  </div>
                  <div className={testi.lista2}>
                    <NavLink href='/help_center/watch_videos' name='Ver videos' className={testi.button1} />
                  </div>

                </div>

              </div>
            </div>

            <div className={testi.column} />

          </div>

        </div>

        <div className={testi.body_section2}>

          <div className={testi.altura} />
          <div className={testi.search_container}>
            <Image
              src='/img/icons/search.svg' alt='search icon' className={testi.search_icon}
              width={25}
              height={25}
            />

            <input type='text' placeholder='Buscador' className={testi.search_input} />
          </div>

          {
             helplistGrups.map((group, index) => (

               <div className={testi.body_section1} key={index}>

                 {
                       group.map((helplist, index) => (
                         <HelpList {...helplist} key={index} />
                       ))
                    }
               </div>
             ))
          }
        </div>

      </div>
      <Footer />
    </>
  )
}
